const doc = [({"da":({"js":({"admin":({"templates":({"create_card":({"create_template":"Opret skabelon"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;